export default {
  chapterReadingTimePause: 'chapter_reading_time_pause',
  chapterReadingTimeStart: 'chapter_reading_time_start',
  flashcardsLearningTimePause: 'flashcards_learning_time_pause',
  flashcardsLearningTimeStart: 'flashcards_learning_time_start',
  videoWatchingTimePause: 'video_watching_time_pause',
  videoWatchingTimeStart: 'video_watching_time_start',
  learningTimeChartLoading: 'learning_time_chart_loading'
}
